import React from "react";
import "./ErrorPage.css";

const ERROR_HEADINGS = {
  404: "❗The requested resource could not be found.",
  429: "❗Your access to this service has been temporarily limited.",
  503: "❗The service is temporarily unavailable.",
  default: "❗Unable to access this service.",
};

const ErrorPage = ({ error, errorStatus }) => {
  const errorHeading =
    ERROR_HEADINGS[errorStatus] || ERROR_HEADINGS.default;
return (
    <div className="wf-wrapper">
      <div className="wf-card">
        <div className="wf-header wf-header-warning">
          <h>{errorStatus === 404 && "🔍"}
  {errorStatus === 429 && "⏳"}
  {errorStatus === 503 && "🛠️"}
  {!errorStatus && "⚠️"}
  {errorStatus}
</h>
          <h1>{error}</h1>
        </div>

        <div className="wf-body">
          <p className="wf-desc">
            {errorHeading}
            {errorStatus && (
              <>
                {" "}
                {/* <strong>(HTTP response code {errorStatus})</strong> */}
              </>
            )}
          </p>

          <p className="wf-sub">
            If you believe this is an error, please try again after some time.
          </p>

          <div className="wf-links">
            <a href="/" className="wf-link">
             🏠 Return to home page
            </a>

            {/* <button
              className="wf-link wf-btn"
              onClick={() => window.location.reload()}
            >
                  🔄 Try again
            </button> */}
          </div>

          <div className="wf-tech">
            <div className="wf-tech-row">
              <span className="wf-tech-label">Status Code:</span>
              <span>HTTP {errorStatus || "N/A"}</span>
            </div>
            <div className="wf-tech-row">
              <span className="wf-tech-label">Time:</span>
              <span>
  {new Date().toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true
  })}
</span>

            </div>
          </div>
        </div>

        <div className="wf-footer">
          <span>🛡️ Protected by application security rules</span>
        </div>
      </div>
    </div>
  );
}

export default ErrorPage;